/**
 * Formattatori condivisi dei tre file del modulo contratti (elenco,
 * dettaglio, form): una funzione sola, non tre copie che potrebbero
 * divergere alla prima modifica (review controllore 2026-08-03, round 2,
 * medio 7 - la stessa dottrina di piano.py/importi.py per i calcoli, qui per
 * la formattazione: "e' il germe delle divergenze").
 *
 * `fmtDate` compone la data dalle sue parti (split della stringa), MAI
 * `new Date("YYYY-MM-DD")`: quella sintassi ECMA-262 e' interpretata come
 * mezzanotte UTC, e un runtime con timezone diverso da quello atteso puo'
 * mostrare il giorno sbagliato - stessa classe del bug gia' corretto su
 * `oggiISO` (fix-fuso-report.md; review controllore 2026-08-03 grave 11,
 * round 2 medio 8: "a due righe da dove l'abbiamo chiuso").
 */

export const VUOTO = '-';

/** Data da una stringa "YYYY-MM-DD" (o "YYYY-MM-DDTHH:MM:SS..."): le parti
 * si leggono dalla stringa e si passano al costruttore Date(anno, mese,
 * giorno), che e' SEMPRE locale - mai un giro per l'UTC. */
export const fmtDate = (s: string | null | undefined): string => {
  if (!s) return VUOTO;
  const soloData = s.split('T')[0];
  const [anno, mese, giorno] = soloData.split('-').map(Number);
  if (!anno || !mese || !giorno) return VUOTO;
  return new Date(anno, mese - 1, giorno).toLocaleDateString('it-IT');
};

export const fmtEuro = (s: string | null | undefined): string =>
  s == null
    ? VUOTO
    : new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(s));

/** Prima lettera maiuscola: la periodicita' arriva dal backend in minuscolo
 * ("mensile", "annuale"), qui e' testo per un umano, non un codice. */
export const capitalizza = (s: string): string =>
  s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
